import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const HH_MM_SS = /^(\d{2}):(\d{2}):(\d{2})$/;

export function maxDurationValidator(maxSeconds: number): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const match = HH_MM_SS.exec(control.value);
    if (!match) {
      return null;
    }

    const totalSeconds = Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3]);

    return totalSeconds > maxSeconds ? { maxDuration: maxSeconds } : null;
  };
}
